export default __webpack_public_path__ + "static/media/workspace-intro-left.1a078e0b.png";